/** Dispatched by TDHeader's assistant control; handled by FrontdoorAgentFlyout. */
export const OPEN_ASSIST_FLYOUT_EVENT = "mxp:open-assist"

export function openAssistFlyout(): void {
  window.dispatchEvent(new CustomEvent(OPEN_ASSIST_FLYOUT_EVENT))
}
